module.exports = __webpack_public_path__ + "img/a5.f2221fb9.jpeg";